import { Grid } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import {
  GENERAL_TEXT_COLOR,
  NAV_FONT_FAMILY,
  SIGNED_IN_NAV_TEXT_COLOR,
} from '../../../../config/consts';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > div': {
      // maxWidth: 40,
      width: '100%',
      backgroundColor: SIGNED_IN_NAV_TEXT_COLOR,
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    // backgroundColor: 'pink',
    '&:focus': {
      opacity: 1,
    },
    outline: '0 !important',
    padding: '0 !important',
    display: 'flex',
    minWidth: '20px !important',
    fontFamily: NAV_FONT_FAMILY,
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}));

export default function GeneralTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  // const secundary = '#505050';

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid item container xs={12} className={classes.root}>
      {props.hiddenTabs ? (
        <Grid
          item
          container
          xs={12}
          alignItems="center"
          component={props.component}
        >
          {props.start}
        </Grid>
      ) : (
        <Grid item container xs={12}>
          <AppBar className={classes.appBar} position="static">
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="Tabs"
              style={{
                marginBottom: '1rem',
              }}
            >
              <StyledTab
                style={{
                  color: value === 0 ? GENERAL_TEXT_COLOR : SIGNED_IN_NAV_TEXT_COLOR,
                  marginRight: '1rem',
                }}
                label="Geral"
                {...a11yProps(0)}
              />
              <StyledTab
                style={{
                  color: value === 1 ? GENERAL_TEXT_COLOR : SIGNED_IN_NAV_TEXT_COLOR,
                }}
                label="Regulamento"
                {...a11yProps(1)}
              />
            </StyledTabs>
          </AppBar>
          <Grid item container xs={12} component="section">
            {value === 0 ? props.start : value === 1 ? props.rules : null}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
